/* Find all slideshow containers */
var slideshowContainers = document.getElementsByClassName("slideshow__slides");
/* For each container get starting variables */
for(let s = 0; s < slideshowContainers.length; s++) {
    /* Read the new data attribute */        
    var cycle = slideshowContainers[s].dataset.cycle;
    /* Find all the child nodes with class mySlides */
    var slides = slideshowContainers[s].querySelectorAll('.slideshow__slide');
    var slideIndex = 0;
    /* Now we can cycle slides, but this recursive function must have parameters */
    /* slides and cycle never change, those are unique for each slide container */
    /* slideIndex will increase during each iteration */
    showSlides(slides, slideIndex, cycle);
};

/* Function is alsmost same, but now it uses 3 new parameters */
function showSlides(slides, slideIndex, cycle) {
    for (let i = 0; i < slides.length; i++) {
        slides[i].style.opacity = "0";
    };
    slideIndex++;
    if (slideIndex > slides.length) {
        slideIndex = 1
    };
    slides[slideIndex - 1].style.opacity = "1";
    /* Calling same function, but with new parameters and cycle time */
    setTimeout(function() {
        showSlides(slides, slideIndex, cycle)
    }, cycle);
};

function initHomepageFloatingUi() {
    var parallax = document.querySelector('.template-index .parallax');
    var footer = document.getElementById('index-page-footer');
    var finalCtaSection = document.getElementById('group24');
    var shopNow = document.getElementById('shop-now-fixed');
    var arrows = document.getElementById('sd-container');

    if (!parallax || !footer || (!shopNow && !arrows)) return;

    var revealAfter = Math.max(60, Math.round(parallax.clientHeight * 0.12));

    function updateUi() {
        var footerRect = footer.getBoundingClientRect();
        var parallaxRect = parallax.getBoundingClientRect();
        var footerVisible = footerRect.top < parallaxRect.bottom && footerRect.bottom > parallaxRect.top;
        var pastRevealPoint = parallax.scrollTop > revealAfter;

        var finalCtaVisible = false;
        if (finalCtaSection) {
            var finalCtaRect = finalCtaSection.getBoundingClientRect();
            finalCtaVisible = finalCtaRect.top < parallaxRect.bottom && finalCtaRect.bottom > parallaxRect.top;
        }

        if (arrows) {
            arrows.classList.toggle('homepage-floating-hidden', footerVisible);
        }

        if (shopNow) {
            shopNow.classList.toggle('homepage-floating-hidden', footerVisible || finalCtaVisible);
            shopNow.classList.toggle(
                'homepage-floating-active',
                pastRevealPoint && !footerVisible && !finalCtaVisible
            );
        }
    }

    if (window.__spcHomepageFloatingHandler && window.__spcHomepageFloatingTarget) {
        window.__spcHomepageFloatingTarget.removeEventListener(
            'scroll',
            window.__spcHomepageFloatingHandler
        );
        window.removeEventListener('resize', window.__spcHomepageFloatingHandler);
    }

    window.__spcHomepageFloatingTarget = parallax;
    window.__spcHomepageFloatingHandler = updateUi;

    parallax.addEventListener('scroll', updateUi, { passive: true });
    window.addEventListener('resize', updateUi);

    updateUi();
}

document.addEventListener('DOMContentLoaded', initHomepageFloatingUi);
document.addEventListener('shopify:section:load', initHomepageFloatingUi);


function initHomepageParallaxAnimations() {
    var parallax = document.querySelector('.template-index .parallax');
    if (!parallax) return;

    var animatedElements = Array.prototype.slice.call(
        parallax.querySelectorAll('[data-animate]')
    );

    if (!animatedElements.length) return;

    if (
        window.__spcParallaxAnimationTarget &&
        window.__spcParallaxAnimationScrollHandler
    ) {
        window.__spcParallaxAnimationTarget.removeEventListener(
            'scroll',
            window.__spcParallaxAnimationScrollHandler
        );
        window.removeEventListener(
            'resize',
            window.__spcParallaxAnimationScrollHandler
        );
    }

    function checkParallaxAnimations() {
        var parallaxRect = parallax.getBoundingClientRect();

        animatedElements = animatedElements.filter(function(el) {
            if (el.classList.contains('has-animated')) {
                return false;
            }

            var rect = el.getBoundingClientRect();
            var isVisible =
                rect.top <= parallaxRect.bottom - 60 &&
                rect.bottom >= parallaxRect.top + 40;

            if (isVisible) {
                el.classList.add('has-animated');

                if (window.jQuery) {
                    window.jQuery(el).trigger('animate_element', [el]);
                }

                return false;
            }

            return true;
        });

        if (!animatedElements.length) {
            parallax.removeEventListener('scroll', checkParallaxAnimations);
            window.removeEventListener('resize', checkParallaxAnimations);
        }
    }

    window.__spcParallaxAnimationTarget = parallax;
    window.__spcParallaxAnimationScrollHandler = checkParallaxAnimations;

    parallax.addEventListener('scroll', checkParallaxAnimations, { passive: true });
    window.addEventListener('resize', checkParallaxAnimations);

    checkParallaxAnimations();
}

document.addEventListener('DOMContentLoaded', initHomepageParallaxAnimations);
document.addEventListener('shopify:section:load', initHomepageParallaxAnimations);

document.addEventListener('DOMContentLoaded', initHomepageFloatingUi);
document.addEventListener('shopify:section:load', initHomepageFloatingUi);